const Environment = {
  BASE_URL: import.meta.env.VITE_BASE_URL as string,
}

export default Environment
